"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var DistributionDimension;
(function (DistributionDimension) {
    DistributionDimension["Browser"] = "browser";
    DistributionDimension["Os"] = "os";
    DistributionDimension["BrowserVersion"] = "browserversion";
    DistributionDimension["TopBrowsers"] = "topbrowsers";
    DistributionDimension["Device"] = "device";
})(DistributionDimension = exports.DistributionDimension || (exports.DistributionDimension = {}));
//# sourceMappingURL=traffic.distribution.model.js.map